import {Injectable} from '@angular/core';
import { SessionService } from '../../../shared/session-service/session.service';
import { Project } from '../../models/project.model';
import {API_URL} from '../../../shared/constants/apiurl-constants';

@Injectable({providedIn: 'root'})
export class EpAddProjectService {
  constructor(private sessionService: SessionService) {}

  addProject(data: Project) {
    return this.sessionService.apiUrlPost(API_URL.ADDPROJECT, data);
  }

  updateProject(data: any) {
    return this.sessionService.apiUrlPost(API_URL.UPDATEPROJECT, data);
  }
}
